import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupScriptsPlugin from '@swup/scripts-plugin';
// import Splide from '@splidejs/splide';
// import AOS from 'aos';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';

import accordion from "./components/accordion";
 

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

const swup = new Swup({
  plugins: [new SwupBodyClassPlugin()]
}); 


// Events
swup.on('contentReplaced', init);



// Start Apline after swup so it works correctly
window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.data('accordion', accordion)
Alpine.start();


document.addEventListener("DOMContentLoaded", () => {
  l('ready');
  // checkCookie();
  init();
});

// Functions 
function l(m) { 
  console.log(m); 
}

function init() {
  l('👍');
  scrollToTop();

  // startSliders();
  // cookieNotice();
  // lazyImages();
}

function scrollToTop() {
  window.scrollTo({
      top: 0,
      behavior: "smooth"
  });
}

// function aosInit() {
//   AOS.init({
//     duration: 450,
//     once: false,
//   });
// }



// function startSliders() {
//   if(document.querySelectorAll('.splide').length) { 
//     let perPage = isMobile ? 1.5 : 3.5;
//     let splide = new Splide( '.splide', {
//       type: 'loop',
//       focus  : 'left',
//       perPage: perPage,
//       arrows: true,
//       pagination: false
//     });

//     splide.mount();
//   }

// }

// function cookieNotice() {
//   l('cookienotice');
//   document.querySelector('.cookie_btn').addEventListener('click', setCookie);
// }

// function setCookie() {
//   l('set cookie');
//   document.cookie = 'cookie-note=1;max-age=864000';
//   document.querySelector('.cookie').classList.add('hidden');
// }